// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.title[data-v-68b5bc44] {\n    vertical-align: bottom;\n    padding-right: 10px;\n}\n.value[data-v-68b5bc44] {\n    vertical-align: bottom;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
